import { stripTags, translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { StyledBadge, StyledDescription, StyledTitle } from "./styled";
import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";
import { TruncateWithTooltip } from "@kaltura/mediaspace-shared-ui";
import { useContext } from "react";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config";

export interface CategoryHeaderBasicMetadataProps {
    isChannel: boolean;
    name: string;
    description: string;
    channelRank?: string;
    onReadMore?: (showMore: boolean) => void;
}

/**
 *  Main text items of the category header - shared between the channel's and gallery's header.
 */
export const CategoryHeaderBasicMetadata = ({
    isChannel,
    name,
    description = "",
    channelRank = "",
    onReadMore,
}: CategoryHeaderBasicMetadataProps) => {
    const theme = useTheme();

    const isMediumScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.lg));

    const isSmallScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    const categoryName = !isKaf ? name : translate("Media Gallery");

    // take only the first row in the description (split by "<br" to support all br tag syntaxes - <br> <br /> <br/>)
    const descriptionFirstLine = description.split("<br")[0];
    // strip &nbsp and html tags except a,i,b,u
    const descriptionPlain = stripTags(descriptionFirstLine, ["a", "i", "b", "u"]);

    return (
        <>
            <TruncateWithTooltip text={categoryName} lines={3}>
                <StyledTitle component={"h1"} variant={isSmallScreen ? "h3" : isMediumScreen ? "h2" : "h1"}>
                    {categoryName}
                </StyledTitle>
            </TruncateWithTooltip>

            {channelRank && <StyledBadge label={channelRank} />}

            {(!isChannel || !isSmallScreen) && (
                <StyledDescription
                    className={"kms-ds-channel-page-header-text-description"}
                    lines={3}
                    showMoreTranslatedText={translate("Read More")}
                    toggleMoreClassName={"channel-page-desc-more"}
                    onToggle={onReadMore}
                    preventStateUpdate={!!onReadMore}
                    translucent={isChannel}
                >
                    {HtmlReactParser(descriptionPlain)}
                </StyledDescription>
            )}
        </>
    );
};
